import {
  isAccommodationV2Item,
  isBNBLLEHotelItem,
  isCruiseItem,
  isTourV2Item,
} from 'lib/checkout/checkoutUtils'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'

export function checkoutAccommodationGroupingKey(item: App.Checkout.AccommodationItem): string {
  if (isBNBLLEHotelItem(item)) {
    return `${item.offerId}-bnbl-${item.duration}`
  }

  else if (isTourV2Item(item)) {
    return `${item.offerId}-${item.purchasableOption.fkDepartureId}`
  }

  else if (isCruiseItem(item)) {
    return `${item.offerId}-${item.departureId}`
  }

  else if (item.itemType === 'tourV1') {
    return `${item.offerId}-${item.startDate}-${item.endDate}`
  }

  else {
    return `${item.offerId}-${item.checkIn}-${item.checkOut}`
  }
}

export function getItemUniqueKey(item: App.Checkout.AccommodationItem): string {
  if (item.itemType === 'bedbankHotel') return item.roomId
  if (item.itemType === 'tourV1') return item.packageId
  if (isTourV2Item(item)) return item.purchasableOption.fkDepartureId
  if (isCruiseItem(item)) return item.departureId
  if (isAccommodationV2Item(item)) {
    const { adults, teenagers = 0, children = 0, infants = 0 } = item.occupancy
    return `${item.roomId}:${item.optionId}:${item.internalRateId}:${item.checkIn}:${item.checkOut}:${adults}-${teenagers}-${children}-${infants}`
  }
  return getPackageUniqueKey(item.packageId, item.duration, item.roomRateId)
}

export function getPackageId(item: App.Checkout.AccommodationItem): string {
  if (item.itemType === 'bedbankHotel') return item.roomId
  if (isTourV2Item(item)) return item.purchasableOption.fkDepartureId
  if (isCruiseItem(item)) return item.departureId
  if (isAccommodationV2Item(item)) return item.optionId

  return item.packageId
}
